import { ButtonProps } from '@material-ui/core';
import { Check, PlaylistAddCheck, Save, Send, Warning } from '@material-ui/icons';
import EditIcon from '@material-ui/icons/Edit';
import React from 'react';
import { tKey } from '../../../helpers/translate';

const buttonOnSave: ButtonProps = {
  startIcon: <Save />,
  fullWidth: true,
  variant: 'contained',
  color: 'primary',
  hidden: true,
};

const buttonOnSend: ButtonProps = {
  startIcon: <Send />,
  fullWidth: true,
  variant: 'contained',
  color: 'primary',
  hidden: true,
};

const buttonOnAccept: ButtonProps = {
  startIcon: <Check />,
  fullWidth: true,
  variant: 'contained',
  color: 'primary',
  hidden: true,
};

const buttonOnReject: ButtonProps = {
  startIcon: <Warning />,
  fullWidth: true,
  variant: 'contained',
  color: 'primary',
  hidden: true,
};

const buttonOnConfirm: ButtonProps = {
  startIcon: <Check />,
  fullWidth: true,
  variant: 'contained',
  color: 'primary',
  hidden: true,
};

const buttonToAccounting: ButtonProps = {
  startIcon: <PlaylistAddCheck />,
  fullWidth: true,
  variant: 'contained',
  color: 'primary',
  hidden: true,
};

const buttonAuthorize: ButtonProps = {
  startIcon: <Check />,
  fullWidth: true,
  variant: 'contained',
  color: 'primary',
  hidden: true,
};

const buttonModify: ButtonProps = {
  startIcon: <EditIcon />,
  fullWidth: true,
  variant: 'contained',
  color: 'primary',
  hidden: true,
};

export interface InvoiceButtons {
  buttonOnSave: ButtonProps;
  buttonOnSend: ButtonProps;
  buttonOnAccept: ButtonProps;
  buttonOnReject: ButtonProps;
  buttonOnConfirm: ButtonProps;
  buttonToAccounting: ButtonProps;
  buttonAuthorize: ButtonProps;
  buttonModify: ButtonProps;
}

export const buttonsInvoice = () => {
  buttonOnSave.children = tKey('invoice.actions.save').toLocaleUpperCase();
  buttonOnSend.children = tKey('invoice.actions.send').toLocaleUpperCase();
  buttonOnAccept.children = tKey('invoice.actions.accept').toLocaleUpperCase();
  buttonOnReject.children = tKey('invoice.actions.reject').toLocaleUpperCase();
  buttonOnConfirm.children = tKey('invoice.actions.confirm').toLocaleUpperCase();
  buttonToAccounting.children = tKey('invoice.actions.to_accounting').toLocaleUpperCase();
  buttonAuthorize.children = tKey('invoice.actions.authorize').toLocaleUpperCase();
  buttonModify.children = tKey('invoice.actions.modify').toLocaleUpperCase();

  return {
    buttonOnSave,
    buttonOnSend,
    buttonOnAccept,
    buttonOnReject,
    buttonOnConfirm,
    buttonToAccounting,
    buttonAuthorize,
    buttonModify,
  };
};

export type ButtonsInvoiceType = typeof buttonsInvoice;
